import { makeStyles } from 'lib/components';

const useStyles = makeStyles((theme) => ({
  fieldContainer: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  heading: {
    width: '60%',
    height: '32px',
    marginBottom: theme.spacing(3),
  },
  card: {
    width: '100%',
    height: '200px',
    borderRadius: theme.shape.borderRadius,
  },
  table: {
    width: '100%',
    height: '400px',
    borderRadius: theme.shape.borderRadius,
  },
  tableHeader: {
    backgroundColor: theme.palette.grey[100],
    padding: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
  },
  headerCell: {
    width: '90%',
    height: '24px',
    margin: theme.spacing(0, 1),
  },
  tableRow: {
    padding: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
    },
  },
  cell: {
    width: '90%',
    height: '20px',
    margin: theme.spacing(0, 1),
  },
}));

export default useStyles;
